import PurchasedCustomPrintUpdateStatusModalContainer from './PurchasedCustomPrintUpdateStatusModalContainer';

export default PurchasedCustomPrintUpdateStatusModalContainer;
